var styles = {"autoSizeTextArea":"styles_auto-size-text-area__tsJ6N","preview":"styles_preview__Xjj1F","input":"styles_input__-EGs2"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
